<template>
	<div>
		<Modal v-model="showModal" width="450px;" :footer-hide="true">
			<div style="padding: 20px;">
				<div class="topModelBox">
					<div class="inputBox" style="border: 1px #dedede solid;line-height: 50px;">
						<b style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color: #808695;margin-left: 15px;">
							<span v-if="currentNumber!='' && currentNumber>=0">{{currentNumber}}</span>
							<span v-else>请输入，最大限制{{maxNumber}}</span>
						</b>
					</div>
					<Button v-if="sortingData.is_weight==1" class="operationButton" :class="{active:active==1}">{{sortingData.base_unit}}</Button>
					<Button v-if="sortingData.is_weight==2 && sortingData.product_cache.specifications!=sortingData.base_unit"
					        class="operationButton" :class="{active:active==1}" @click="active=1">
						<span v-if="active==2 && currentNumber">{{NumberUtil.div(currentNumber,sortingData.unit_conversion)}}</span>
						{{sortingData.product_cache.specifications}}
					</Button>
					<Button v-if="sortingData.is_weight==2&& sortingData.product_cache.specifications!=sortingData.base_unit"
					        class="operationButton" :class="{active:active==2}" @click="active=2">
						<span v-if="active==1 && currentNumber">{{NumberUtil.mul(currentNumber,sortingData.unit_conversion)}}</span>
						{{sortingData.base_unit}}
					</Button>
				</div>
				<Row :gutter="12" style="margin-top: 15px;">
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('1')">
							<b style="font-size: 50px">1</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('2')">
							<b style="font-size: 50px">2</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('3')">
							<b style="font-size: 50px">3</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('del')">
							<b style="font-size: 50px">←</b>
						</Button>
					</Col>
				</Row>
				<Row :gutter="12" style="margin-top: 15px;">
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('4')">
							<b style="font-size: 50px">4</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('5')">
							<b style="font-size: 50px">5</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('6')">
							<b style="font-size: 50px">6</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('.')" :disabled="!showCanDecimal">
							<b style="font-size: 50px">.</b>
						</Button>
					</Col>
				</Row>
				<Row :gutter="12" style="margin-top: 15px;">
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('7')">
							<b style="font-size: 50px">7</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('8')">
							<b style="font-size: 50px">8</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('9')">
							<b style="font-size: 50px">9</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('clear')">
							<b style="font-size: 25px">清空</b>
						</Button>
					</Col>
				</Row>
				<Row :gutter="12" style="margin-top: 15px;">
					<Col span="6">
						<Button class="numberBtn" @click="showModal=false">
							<b style="font-size: 25px">取消</b>
						</Button>
					</Col>
					<Col span="6">
						<Button class="numberBtn" @click="btnClick('0')">
							<b style="font-size: 50px">0</b>
						</Button>
					</Col>
					<Col span="12">
						<Button
							@click="submitData"
							style="height: 85px;width:183px;border: 1px #dedede solid;text-align: center;line-height: 85px;background-color: #6699CC;color: #F0F0F0">
							<b style="font-size: 25px">确认</b>
						</Button>
					</Col>
				</Row>
			</div>
		</Modal>
	</div>
</template>

<script>
	const NumberUtil = require("../../util/NumberUtil");

	export default {
		name: "keyboard",
		props: {
			// 最小小数位数
			decimalPlace: {
				type: Number,
				default: 3
			},
			// 最大限制
			maxNumber: {
				type: Number,
				default: 99999
			},
			// 是否支持小数
			canDecimal: {
				type: Boolean,
				default: true
			},
			/*buttonOne:{
				type: Number/String,
				default: ''
			},
			buttonTwo:{
				type: Number/String,
				default: ''
			}*/
		},
		data() {
			return {
				NumberUtil,
				// 销售单位基本单位选中索引
				active: 1,
				showCanDecimal: true,
				showModal: false,
				// 当前录入
				currentNumber: "",
				// 当前分拣数据
				sortingData: {}
			}
		},
		created() {
			this.showCanDecimal = this.canDecimal;
		},
		methods: {
			/*toEmit(value){
				// 返回点击事件
				this.$emit(value,"")
			},*/
			// 展示窗口
			showKeyboardModal(data) {
				this.showModal = true;
				this.currentNumber = "";
				this.active = 1;
				this.sortingData = data;
			},
			// 点击数字
			btnClick(number) {
				if (number === "del") {
					if (this.currentNumber) {
						this.currentNumber = this.currentNumber.substring(0, this.currentNumber.length - 1);
					}
				} else if (number === ".") {
					if (this.currentNumber.includes(".") || !this.currentNumber) {
						return this.$Message.error("输入有误！");
					} else {
						let numner = this.currentNumber + number;
						if (numner > this.maxNumber) {
							return this.$Message.warning("最大限制输入" + this.maxNumber);
						}
						this.currentNumber += number;
					}
				} else if (number === "clear") {
					this.currentNumber = "";
				} else {
					// 判断小数位
					if (this.currentNumber.includes(".")) {
						if (this.currentNumber.split(".")[1].length >= this.decimalPlace) {
							return this.$Message.warning("最多支持保留" + this.decimalPlace + "位小数");
						}
					}
					let numner = this.currentNumber + number;
					if (numner > this.maxNumber) {
						return this.$Message.warning("最大限制输入" + this.maxNumber);
					}
					this.currentNumber += number;
				}

				// 判断首位是否为0
				// if (this.currentNumber.length > 1) {
				// 	if (this.currentNumber.substring(0, 1) == "0") {
				// 		this.currentNumber = this.currentNumber.replace("0", "");
				// 	}
				// }
				// this.currentNumber = Number(this.currentNumber) + "";
				// console.log(this.currentNumber)

			},
			// 提交数据
			submitData() {
				if (!this.currentNumber) {
					return this.$Message.warning("数字为空！");
				}
				// 判断小数点后有没有数字
				if (!this.currentNumber.split(".")[1]) {
					this.currentNumber = this.currentNumber.replace(".", "");
				}
				let number = Number(this.currentNumber);
				// 如果录入是基本单位进行单位转换
				if (this.active == 2) {
					number = NumberUtil.div(number, this.sortingData.unit_conversion)
				}
        console.log(number)
        // return
				this.$emit('reciveData', {data: number});
				this.showModal = false;

			}
		},
		mounted() {
		},
		watch: {
			canDecimal(newValue, oldValue) {
				this.showCanDecimal = newValue
			}
		}
	}
</script>

<style scoped lang="less">
	.numberBtn {
		height: 85px;
		width: 85px;
		border: 1px #dedede solid;
		text-align: center;
		line-height: 85px
	}

	.topModelBox {
		width: 100%;
		display: flex;
		align-items: center;

		.inputBox {
			flex-grow: 1;
		}

		.operationButton {
			height: 53px;
			padding: 10px;
			color: #333;
			margin-left: 4px;
			min-width: 56px;
			text-align: center;
			border-radius: 2px;
			font-weight: bold;
			box-sizing: border-box;
			border: 1px #dedede solid;
			background-color: #f0f5ff;

			&.active {
				color: #F0F0F0;
				background-color: #6699CC;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/keyboard/keyboard.vue